export const capitalizeFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const sortByPosition = (dataArray) => dataArray.sort((a,b) => a.btnData && b.btnData ? a.btnData.numberInOrder - b.btnData.numberInOrder : a.numberInOrder - b.numberInOrder);

export const getArrayLastItem = (array) => array[array.length - 1];

export const checkExternalUrl = (url) => url.includes("http", "https") ? url : `https://${url}`;

export const transformSnakeToCamelCase = (text) => text.includes("_") ? text.split("_").map((part, i) => i === 0 ? part : capitalizeFirstLetter(part)).join("") : text;

export const transformCamelCaseToSnakeCase = (text) => text.split("").map((letter) => {
  if (letter === "_") return letter;
  return letter === letter.toUpperCase() ? `_${letter.toLowerCase()}` : letter
}).join("");

export function customJsonParser(data, keyFormatter) {
  if (typeof(keyFormatter) !== "function") return data;
  let jsonData = data;
  if (typeof(data) === "object") jsonData = JSON.stringify(data);

  return JSON.parse(jsonData, function(key, value) {
    const reg = /^\d+$/;
    if (reg.test(key)) return value;
    const newKey = keyFormatter(key);
    if (key !== newKey) {
      this[newKey] = value;
      return;
    }
    return value;
  });
};

export const sendMessageToParentFrame = (message, from = "cc-child") => {
  window.parent.postMessage(
    {
      from: from,
      message: message,
    },
    "*",
  );
};
